import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/InheritanceParameters.module.css";
import Info from "../Info/info";
import { Switch } from "@mui/material";
import KeepAlive from "./KeepAlive";
import Frequency from "./Frequency";
import { useNavigate, useLocation } from "react-router-dom";
import { UserData } from "../../../Context/DataContext";
import { formatDate } from "../../../Utils/formatDate";
import { formatTime } from "../../../Utils/formatTime";
import { getReferralData } from "../../../Utils/ReferralUtils";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import parse from "html-react-parser";

function InheritanceParameters() {
  const userData = UserData();
  const navigate = useNavigate();
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.InheritanceParameters.InheritanceParameters
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(
      websiteCurrentLang.content.User.InheritanceParameters
        .InheritanceParameters
    );
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [isAnimationStarted, setIsAnimationStarted] = useState(false);

  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash === "") {
      window.scrollTo(0, 0);
    } else {
      setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);

        if (element) {
          var innerHeight_Half = window.innerHeight >> 1;
          var elementRect = element.getBoundingClientRect();

          window.scrollBy(
            elementRect.left >> 1,
            elementRect.top - innerHeight_Half
          );
        }
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("animated-section");
      if (!section) return;

      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top;
      const sectionBottom = rect.bottom;
      const viewportHeight = window.innerHeight;

      if (
        sectionTop < viewportHeight / 2 &&
        sectionBottom > viewportHeight / 2
      ) {
        setIsAnimationStarted(true);
      }
    };

    // const Weglot = document.createElement("script")
    // Weglot.src = "https://cdn.weglot.com/weglot.min.js"
    // document.body.appendChild(Weglot)
    // Weglot.onload = () =>{
    //   console.log('Script is loaded')
    //   window.Weglot.initialize({
    //     api_key: 'wg_fe59e91dbf7c41abd8908f1b88215ff17',
    //   });
    // }

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    getReferralData()
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        console.log(data);
      })
      .catch((e) => console.log(e));
  }, []);
  const getTransitionDelay = (order) => {
    // You can calculate the transition delay based on the order here.
    // For this example, we'll use a fixed value of 0.2 seconds for each element.
    return `${order * 0.4}s`;
  };

  return (
    <div className={styles.main}>
      <div className={styles.title}>{content.InheritanceParametersTitle1}</div>
      <div className={styles.upper_box}>
        <div className={styles.left}>
          <div className={styles.field}>
            <div className={styles.bold_div}>
              <div className={styles.bold_title}>
                {content.InheritanceParametersText1}
              </div>
              <Info message={content.InheritanceParametersText2} />
            </div>
            <KeepAlive
              translation={dublicatedcontent}
              confirm_button={dublicatedcontent?.im_alive}
              text={dublicatedcontent?.keep_alive_pending_notification}
              disabled={userData.isFreezed}
              value="Email"
            />
          </div>

          <div className={styles.field} id="frequency">
            <div className={styles.bold_div}>
              <div className={styles.bold_title}>
                {content.InheritanceParametersText3}
              </div>
              <Info message={content.InheritanceParametersText4} />
            </div>
            <Frequency
              disabled={userData.isFreezed}
              timeContent={dublicatedcontent}
              float_message={dublicatedcontent?.saved}
            />
            <div className={styles.data}>
              {content.InheritanceParametersText5}{" "}
              {formatDate(
                userData.UserData.inheritance_parameters.next_notification
              )}
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.bold_div}>
              <div className={styles.bold_title}>
                {content.InheritanceParametersText6}
              </div>
              <Info message={content.InheritanceParametersText7} />
            </div>
            <div className={styles.text_field}>
              {content.InheritanceParametersText8}{" "}
              <span
                onClick={() => navigate("/user/dashboard#priority1")}
                className={styles.link}
              >
                {content.InheritanceParametersText9}
              </span>
            </div>
          </div>
          <div className={styles.field}>
            <div className={styles.bold_div}>
              <div className={styles.bold_title}>
                {content.InheritanceParametersText10}
              </div>
              <Info message={content.InheritanceParametersText11} />
            </div>
            <div className={styles.text_field}>
              {content.InheritanceParametersText8}{" "}
              <span
                onClick={() => navigate("/user/dashboard#priority2")}
                className={styles.link}
              >
                {content.InheritanceParametersText9}
              </span>
            </div>
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.right_title}>
            {content.InheritanceParametersText12}
          </div>
          {/* <div className={styles.notficiation_rules}>
                        <div className={styles.point}/>
                        {content.InheritanceParametersText12}
                    </div> */}
          <div className={styles.notficiation_rules}>
            <div className={styles.point} />
            {content.InheritanceParametersText13}
          </div>
          <div className={styles.notficiation_rules}>
            <div className={styles.point} />
            {content.InheritanceParametersText14}
          </div>
          <div className={styles.notficiation_rules}>
            <div className={styles.point} />
            {content.InheritanceParametersText15}
          </div>
          <div className={styles.notficiation_rules}>
            <div className={styles.point} />
            {content.InheritanceParametersText16}
          </div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className={styles.rect} />
      </div>
      <div className={styles.box}>
        <div className={styles.low_title}>
          {content.InheritanceParametersText17}
        </div>

        <div
          className={`${styles.animation_block} ${
            isAnimationStarted ? styles.animation_started : ""
          }`}
          id="animated-section"
        >
          <div
            className={`${styles.head} ${styles.fade_in_element}`}
            data-element="fade_in_element"
            show-order="1"
            style={{ transitionDelay: getTransitionDelay(1) }}
          >
            <div className={`${styles.blue_title} ${styles.bold_text}`}>
              {content.InheritanceParametersText18}{" "}
              {formatTime(
                userData.UserData.keep_alive_timeout,
                dublicatedcontent
              )}
            </div>
            <div className={styles.subtext}>
              {content.InheritanceParametersText19}
            </div>

            <div
              className={styles.left_arrow}
              data-element="fade_in_element"
              show-order="4"
              style={{ transitionDelay: getTransitionDelay(4) }}
            ></div>
            <div
              className={styles.right_arrow}
              data-element="fade_in_element"
              show-order="5"
              style={{ transitionDelay: getTransitionDelay(5) }}
            ></div>
          </div>
          <div
            className={styles.lineup}
            show-order="2"
            data-element="fade_in_element"
            style={{ transitionDelay: getTransitionDelay(2) }}
          ></div>
          <div
            className={styles.blue_notification}
            show-order="3"
            data-element="fade_in_element"
            style={{ transitionDelay: getTransitionDelay(3) }}
          >
            {content.InheritanceParametersText20}
          </div>

          <div className={styles.animation_block_bottom}>
            <div
              className={styles.red_notification}
              data-element="fade_in_element"
              show-order="6"
              style={{ transitionDelay: getTransitionDelay(6) }}
            >
              {content.InheritanceParametersText21}
            </div>
            <div
              className={styles.blue_sub}
              data-element="fade_in_element"
              show-order="7"
              style={{ transitionDelay: getTransitionDelay(7) }}
            >
              {content.InheritanceParametersText22}
            </div>
            <div
              className={styles.lineup}
              data-element="fade_in_element"
              show-order="8"
              style={{ transitionDelay: getTransitionDelay(8) }}
            ></div>
            <div
              className={`${styles.text_card} ${styles.right_card} ${styles.text_card_first}`}
              data-element="fade_in_element"
              show-order="8"
              style={{ transitionDelay: getTransitionDelay(8) }}
            >
              <div className={styles.blue_title}>
                {parse(content.InheritanceParametersText23)}{" "}
                {formatTime(
                  userData.UserData.inheritance_parameters.priority_one_delay,
                  dublicatedcontent
                )}
              </div>
              <div className={styles.subtext}>
                {content.InheritanceParametersText24}
              </div>
            </div>
            <div
              className={styles.lineup}
              data-element="fade_in_element"
              show-order="9"
              style={{ transitionDelay: getTransitionDelay(9) }}
            ></div>
            <div
              className={`${styles.text_card} ${styles.left_card} ${styles.text_card_second}`}
              data-element="fade_in_element"
              show-order="9"
              style={{ transitionDelay: getTransitionDelay(9) }}
            >
              <div className={styles.dark_title}>
                {parse(content.InheritanceParametersText25)}
              </div>
              <div className={styles.subtext}>
                {formatTime(
                  userData.UserData.inheritance_parameters.priority_one_delay,
                  dublicatedcontent
                )}{" "}
                {content.InheritanceParametersText26}
              </div>
            </div>
            <div
              className={styles.lineup}
              data-element="fade_in_element"
              show-order="10"
              style={{ transitionDelay: getTransitionDelay(10) }}
            ></div>
            <div
              className={`${styles.text_card} ${styles.right_card} ${styles.text_card_third}`}
              data-element="fade_in_element"
              show-order="10"
              style={{ transitionDelay: getTransitionDelay(10) }}
            >
              <div className={styles.blue_title}>
                {parse(content.InheritanceParametersText27)}
              </div>
              <div className={styles.subtext}>
                {formatTime(
                  userData.UserData.inheritance_parameters.priority_two_delay,
                  dublicatedcontent
                )}{" "}
                {content.InheritanceParametersText28}
              </div>
            </div>
          </div>
        </div>

        <div className={styles.ostreon_title}>
          {parse(content.InheritanceParametersText29)}
        </div>
        <div className={styles.bottom_text}>
          {content.InheritanceParametersText30}{" "}
          <a
            href="https://intercom.help/ostreon-inheritance/en/articles/9022730-ostreon-inheritance-tree"
            target="_blank"
            className={styles.link}
          >
            {content.InheritanceParametersText31}
          </a>{" "}
          {content.InheritanceParametersText32}{" "}
          <a
            href="https://intercom.help/ostreon-inheritance/en/articles/8895357-estate-planning"
            target="_blank"
            className={styles.link}
          >
            {content.InheritanceParametersText33}
          </a>
          .
        </div>
      </div>
    </div>
  );
}

export default InheritanceParameters;
